import { Flex, Tabs } from '@iheartjane/reefer';
import startCase from 'lodash-es/startCase';

import { useStoreSwitcher } from '@jane/bloom/hooks/storeSwitcher/useStoreSwitcher';
import { useCustomLanguage } from '@jane/bloom/hooks/useCustomLanguage';
import type { FulfillmentMode } from '@jane/bloom/types/schemas/bloom/fulfillmentMode';

import styles from './storeSwitcherForm.module.css';

export function StoreSwitcherStoreTypes() {
  const { fulfillmentMode, medStores, recStores, setFulfillmentMode } =
    useStoreSwitcher();
  const customLanguage = useCustomLanguage();

  const customRecLanguage =
    customLanguage.storeComplianceLanguageSettings?.['recreational'];

  const recLabel = customRecLanguage
    ? startCase(customRecLanguage)
    : 'Recreational';

  const hasRecStores = recStores.length > 0;
  const hasMedStores = medStores.length > 0;

  let tabs;

  if ((hasRecStores && hasMedStores) || (!hasRecStores && !hasMedStores)) {
    tabs = [
      { label: 'All', value: 'both' },
      { label: recLabel, value: 'rec' },
      { label: 'Medical', value: 'med' },
    ];
  } else {
    const mode = hasRecStores ? 'rec' : 'med';
    tabs = [{ label: mode === 'rec' ? recLabel : 'Medical', value: mode }];
    setFulfillmentMode(mode);
  }

  const selectType = (val: FulfillmentMode) => {
    setFulfillmentMode(val);
  };

  return (
    <>
      <Flex gap={8} mt={8}>
        <Tabs
          onChange={selectType}
          value={fulfillmentMode}
          id="store-type-tabs"
          tabWidth="101px"
          full
        >
          {tabs.map((type, i) => (
            <Tabs.Tab
              className={
                fulfillmentMode === type.value
                  ? styles['formTabSelected']
                  : styles['formTab']
              }
              value={type.value}
              key={i}
              label={type.label}
              selected={fulfillmentMode === type.value}
            />
          ))}
        </Tabs>
      </Flex>
    </>
  );
}
